<template>
  <div class="content">
    <div class="line">
      <div class="activity-dec">
        <activitya />
      </div>
    </div>
  
     
    <div class="line book"> 
      <img src="../../assets/img/pc/activity/list_title.png" class="title-img" />
      <div class="book-box">
        <div class="list">
          <div class="item" v-for="(item, index) in bookList" :key="index">
            <a :href="item.url" target="_blank" class="book-cover"
              ><img :src="item.cover"
            /></a>
            <div class="info">
              <div class="name ellipsis-1">
                <a :href="item.url" target="_blank">{{ item.name }}</a>
              </div>
              <div class="author">{{ item.author }}</div>
              <div class="dec ellipsis-4">{{ item.intro }}</div>
              <a :href="item.url" target="_blank" class="btn">立即阅读</a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <footera />
      </div>
    </div>

  </div>
</template>

<script>
import { bookList } from "../../assets/js/data";
import footera from "./footer.vue";
import activitya from "./activity.vue";
export default {
  name: "content",
  components: {
    footera,
    activitya
  },
  data() {
    return {
      returnUrl: "",
      contentBg: "",
    };
  },
  created() {
    //this.setAinfo();
  },
  computed: {
    bookList() {
      return bookList;
    },
  },
  methods: {
    //  setAinfo(){//设置活动说明
    //   if(window.location.host=='sxdc.w.chineseall.cn'){ //书香东城
    //     this.ainfo="2022年8月10日前将于“书香东城全民阅读”及“中文在线微书房”公众号公布获奖情况。"
    //   }else{
    //     this.ainfo="2022年8月10日前将于“中文在线微书房”公众号公布获奖情况。"
    //   }
    // },
    getUrl() {},
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content {
  width: 88%;
  height: auto;
  min-height: 100vh;
  margin: 0.3rem auto 0;
  position: relative;
  .line.book {
    position: relative;
    margin-top: 0.2rem;
    .bg-img {
      width: 100%;
      height: 28.71rem;
      position: absolute;
      top: 0;
      left: 0;
    } 
    .prize-dec {
      width: 80%;
      min-width: 800px;
      height: auto;
      position: relative;
      padding: 0.3rem;
      font-size: 0.14rem;
      color: #fbf0b8;
      margin: auto;
      .prize-img {
        width: 100%;
        display: flex;
        justify-content: space-between;
        text-align: center;
        font-size: 0.3rem;
        color: #fbf0b8;
        font-family:'fangsong', 'Source Han Serif SC';
        font-weight: bold;
        .item {
          width: 30%;
          .level {
            font-size: 0.32rem;
            margin-top: 0.2rem;
          }
          .name {
            font-size: 0.26rem;
            margin-top: 0.1rem;
          }

          > img {
            width: 3.5rem;
            height:3.5rem;
            display: block;
            margin: auto;
          }
        }
      }
      .remark {
        margin-top: 0.2rem;
      }
      .activity-box {
        padding: 0 0.6rem;
        text-align: left;
        font-size: 0.3rem;
        font-family: fangsong;
        line-height: 1.6em;
        font-weight: bold;
        .time {
          margin-bottom: 0.3rem;
        }
        .rule{
          margin-top: 0.5rem;
          .title{
            margin-bottom: 0.3rem;
          }
        }
      }
    }
  }
  .line {
    width: 100%;
    margin: 0 auto 0;
    text-align: center;

    .title-img {
      width: 8.73rem;
      height: auto;
      position: relative;
      margin-top: 0.5rem;
    }


    
    .activity-dec {
      width: 100%;
      > p {
        width: 100%;
        text-align: left;
        font-size: 0.2rem;
        line-height: 2em;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #333333;
        text-indent: 2em;
      }
      > p + p {
        margin-top: 0.2rem;
      }
    }

    .book-box {
      width: 99%;
      height: auto;
      padding: 0.62rem 0.3rem 0.88rem 0.98rem;
      background: url(../../assets/img/pc/content/book_bg.png) no-repeat center;
      background-size: 100% 100%;
      position: relative;
      margin: 0.6rem auto 0;
      .list {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .item {
          width: 32%;
          font-size: 0.18rem;
          color: #555454;
          font-weight: 400;
          display: flex;
          align-items: center;
          margin-bottom: 0.3rem;
          .book-cover {
            width: 1.74rem;
            height: 2.32rem;
            > img {
              width: 100%;
              height: 100%;
              box-shadow: 0 0.03rem 0.05rem -0.01rem rgb(0 0 0 / 20%),
                0 0.06rem 0.1rem 0 rgb(0 0 0 / 14%),
                0 1px 18px 0 rgb(0 0 0 / 12%);
            }
          }
          .info {
            width: calc(100% - 1.74rem);
            padding-left: 0.2rem;
            text-align: left;
          }
          a {
            color: #555454;
          }
          .name {
            font-size: 0.22rem;
            font-weight: bold;
            color: #555454;
          }
          .author {
            width: 100%;
            margin-top: 0.16rem;
          }
          .dec {
            margin-top: 0.16rem;
          }
          .btn {
            width: auto;
            height: 0.4rem;
            line-height: 0.4rem;
            background-color: #fed79f;
            border-radius: 0.04rem;
            display: inline-block;
            padding: 0 0.3rem 0;
            font-size: 0.18rem;
            color: #CD0018;
            font-weight: bold;
            text-align: center;
            margin-top: 0.16rem;
          }
        }
      }
    }
  }
}
</style>
